import PropTypes from "prop-types";
import React from "react";

function Waiting(props) {
  return (
    <p className="mt-5 text-center">
      <span>{props.content}</span>
      <i className="ml-2 fas fa-spinner fa-pulse fa-lg" />
    </p>
  );
}

Waiting.defaultProps = {
  content: "لطفا منتظر بمانید",
};

Waiting.propTypes = {
  content: PropTypes.string.isRequired,
};

export default Waiting;
